import Vue from 'vue'
import cookie from 'vue-cookie'

const user = sessionStorage.getItem('loginUser') || cookie.get('loginUser')

const state = {
  loginUser: user ? JSON.parse(user) : {}
}

const getters = {
  loginUser: state => state.loginUser
}

const mutations = {
  SET_LOGIN_USER(state, user) {
    sessionStorage.setItem('loginUser', JSON.stringify(user))
    cookie.set('loginUser', JSON.stringify(user))
    state.loginUser = user
  }
}

const actions = {
  
}

export default {
  state,
  getters,
  mutations,
  actions
}
